"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRouter = require("react-router");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _peractoUi = require("@peracto/peracto-ui");

var _peractoAuth = require("@peracto/peracto-auth");

var _peractoConfig = require("@peracto/peracto-config");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _menuItems = _interopRequireDefault(require("./menuItems"));

var _classnames = _interopRequireDefault(require("classnames"));

var S = _interopRequireWildcard(require("./styled"));

var _faChevronRight = require("@fortawesome/pro-regular-svg-icons/faChevronRight");

var _faPhotoVideo = require("@fortawesome/pro-regular-svg-icons/faPhotoVideo");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Menu = function Menu(_ref) {
  var _user$profile, _user$profile2;

  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      pathname = _ref.location.pathname;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      openMenus = _useState2[0],
      setOpenMenus = _useState2[1];

  var config = (0, _peractoConfig.useConfig)();
  var menu = config.get('menu', _menuItems["default"]);
  var features = config.get('features', {});

  var _useAuth = (0, _peractoAuth.useAuth)(),
      user = _useAuth.user,
      logout = _useAuth.logout;

  var userRoles = (user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.roles) || [];
  var userGroup = (user === null || user === void 0 ? void 0 : (_user$profile2 = user.profile) === null || _user$profile2 === void 0 ? void 0 : _user$profile2.user_group) || [];
  var token = window.localStorage.getItem('token');

  var handleMenuOnResize = function handleMenuOnResize() {
    // Collapse the menu when navigating on tablet / mobile
    if (window.matchMedia('(max-width: 991px)').matches) {
      setOpenMenus({});
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  (0, _react.useEffect)(function () {
    handleMenuOnResize();
  }, [pathname]);
  window.addEventListener('resize', (0, _debounce["default"])(handleMenuOnResize, 200));

  var handleMenuToggle = function handleMenuToggle(menu) {
    setOpenMenus(_objectSpread(_objectSpread({}, openMenus), {}, _defineProperty({}, menu, !openMenus[menu])));
  };

  var getFeatureFlagValue = function getFeatureFlagValue(feature) {
    return feature.split('.').reduce(function (o, i) {
      if (!!o === false || !o.hasOwnProperty(i)) {
        return null;
      }

      return o[i];
    }, features);
  };

  var menuItems = (0, _sortBy["default"])(Object.values(menu), ['sortOrder']);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(S.Styled, {
    className: (0, _classnames["default"])({
      collapsed: !isOpen
    })
  }, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "nav-list"
  }, (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 && menuItems.map(function (menuItem, lvl1idx) {
    var _menuItem$roles, _menuItem$userGroups;

    if (!!menuItem.roles && !(menuItem !== null && menuItem !== void 0 && (_menuItem$roles = menuItem.roles) !== null && _menuItem$roles !== void 0 && _menuItem$roles.some(function (role) {
      return userRoles.includes(role);
    })) || menuItem !== null && menuItem !== void 0 && menuItem.feature && !!getFeatureFlagValue(menuItem === null || menuItem === void 0 ? void 0 : menuItem.feature) === false || (menuItem === null || menuItem === void 0 ? void 0 : (_menuItem$userGroups = menuItem.userGroups) === null || _menuItem$userGroups === void 0 ? void 0 : _menuItem$userGroups.length) > 0 && !menuItem.userGroups.includes(userGroup)) {
      return null;
    }

    if (menuItem !== null && menuItem !== void 0 && menuItem.path && !!(menuItem !== null && menuItem !== void 0 && menuItem.children) === false) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
        key: "menu_".concat(lvl1idx),
        to: menuItem.path,
        activeClassName: "active",
        exact: true,
        className: "nav-list-item",
        "data-testid": "nav-".concat(menuItem.label.toLowerCase().replaceAll(' ', '-'))
      }, /*#__PURE__*/_react["default"].createElement("span", null, menuItem.icon && /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: menuItem.icon,
        className: "nav-icon"
      }), menuItem.label));
    } else {
      var _menuItem$roles2, _menuItem$userGroups2;

      if (!!menuItem.children === false) {
        return null;
      }

      var childMenuItems = (0, _sortBy["default"])(Object.values(menuItem.children), ['sortOrder']);

      if (!!menuItem.roles && !(menuItem !== null && menuItem !== void 0 && (_menuItem$roles2 = menuItem.roles) !== null && _menuItem$roles2 !== void 0 && _menuItem$roles2.some(function (role) {
        return userRoles.includes(role);
      })) || menuItem !== null && menuItem !== void 0 && menuItem.feature && !!getFeatureFlagValue(menuItem === null || menuItem === void 0 ? void 0 : menuItem.feature) === false || (menuItem === null || menuItem === void 0 ? void 0 : (_menuItem$userGroups2 = menuItem.userGroups) === null || _menuItem$userGroups2 === void 0 ? void 0 : _menuItem$userGroups2.length) > 0 && !menuItem.userGroups.includes(userGroup)) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "menu_".concat(lvl1idx)
      }, /*#__PURE__*/_react["default"].createElement("a", {
        onClick: function onClick() {
          return handleMenuToggle(menuItem.label);
        },
        className: "nav-list-item",
        "data-testid": "nav-".concat(menuItem.label.toLowerCase().replaceAll(' ', '-'))
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: menuItem.icon,
        className: "nav-icon",
        "data-testid": "nav-icon-".concat(menuItem.label.toLowerCase().replaceAll(' ', '-'))
      }), menuItem.label), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faChevronRight.faChevronRight,
        className: (0, _classnames["default"])('menu-icon', {
          'menu-icon__open': openMenus[menuItem.label]
        }),
        "data-testid": "nav-chevron-".concat(menuItem.label.toLowerCase().replaceAll(' ', '-'))
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('nav-sublist', {
          'nav-sublist__active': openMenus[menuItem.label]
        })
      }, childMenuItems.map(function (menuItemChild, lvl2Idx) {
        var _menuItemChild$roles, _menuItemChild$userGr;

        if (!!menuItemChild.roles && !(menuItemChild !== null && menuItemChild !== void 0 && (_menuItemChild$roles = menuItemChild.roles) !== null && _menuItemChild$roles !== void 0 && _menuItemChild$roles.some(function (role) {
          return userRoles.includes(role);
        })) || menuItemChild !== null && menuItemChild !== void 0 && menuItemChild.feature && !!getFeatureFlagValue(menuItemChild === null || menuItemChild === void 0 ? void 0 : menuItemChild.feature) === false || (menuItemChild === null || menuItemChild === void 0 ? void 0 : (_menuItemChild$userGr = menuItemChild.userGroups) === null || _menuItemChild$userGr === void 0 ? void 0 : _menuItemChild$userGr.length) > 0 && !menuItemChild.userGroups.includes(userGroup)) {
          return null;
        }

        if (menuItemChild !== null && menuItemChild !== void 0 && menuItemChild.path && !!(menuItemChild !== null && menuItemChild !== void 0 && menuItemChild.children) === false) {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
            key: "menu_".concat(lvl1idx, "_").concat(lvl2Idx),
            to: menuItemChild.path,
            activeClassName: "active",
            className: "nav-list-item",
            "data-testid": "nav-".concat(menuItem.label, "-").concat(menuItemChild.label).toLowerCase().replaceAll(' ', '-')
          }, menuItemChild.label);
        } else {
          if (!!menuItemChild.children === false) {
            return null;
          }

          var grandchildMenuItems = (0, _sortBy["default"])(Object.values(menuItemChild.children), ['sortOrder']);
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
            key: "menu_".concat(lvl1idx, "_").concat(lvl2Idx)
          }, /*#__PURE__*/_react["default"].createElement("a", {
            onClick: function onClick() {
              return handleMenuToggle(menuItemChild.label);
            },
            className: "nav-list-item",
            "data-testid": "nav-".concat(menuItem.label, "-").concat(menuItemChild.label).toLowerCase().replaceAll(' ', '-')
          }, /*#__PURE__*/_react["default"].createElement("span", null, menuItemChild.label), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _faChevronRight.faChevronRight,
            className: (0, _classnames["default"])('menu-icon', {
              'menu-icon__open': openMenus[menuItemChild.label]
            }),
            "data-testid": "nav-chevron-".concat(menuItem.label, "-").concat(menuItemChild.label).toLowerCase().replaceAll(' ', '-')
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames["default"])('nav-sublist', 'nav-sublist__lvl2', {
              'nav-sublist__active': openMenus[menuItemChild.label]
            })
          }, grandchildMenuItems.map(function (grandchildItem, lvl3Idx) {
            var _grandchildItem$roles, _grandchildItem$userG;

            if (!!grandchildItem.roles && !(grandchildItem !== null && grandchildItem !== void 0 && (_grandchildItem$roles = grandchildItem.roles) !== null && _grandchildItem$roles !== void 0 && _grandchildItem$roles.some(function (role) {
              return userRoles.includes(role);
            })) || grandchildItem !== null && grandchildItem !== void 0 && grandchildItem.feature && !!getFeatureFlagValue(grandchildItem === null || grandchildItem === void 0 ? void 0 : grandchildItem.feature) === false || (grandchildItem === null || grandchildItem === void 0 ? void 0 : (_grandchildItem$userG = grandchildItem.userGroups) === null || _grandchildItem$userG === void 0 ? void 0 : _grandchildItem$userG.length) > 0 && !grandchildItem.userGroups.includes(userGroup)) {
              return null;
            }

            return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
              key: "menu_".concat(lvl1idx, "_").concat(lvl2Idx, "_").concat(lvl3Idx),
              to: grandchildItem.path,
              activeClassName: "active",
              className: "nav-list-item",
              "data-testid": "nav-".concat(menuItem.label, "-").concat(menuItemChild.label, "-").concat(grandchildItem.label).toLowerCase().replaceAll(' ', '-')
            }, grandchildItem.label);
          })));
        }
      })));
    }
  }))), /*#__PURE__*/_react["default"].createElement(S.Styled, {
    className: (0, _classnames["default"])({
      collapsed: !isOpen
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nav-list"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "nav-list-item d-flex justify-space-between",
    "data-testid": "nav-file-manager",
    style: {
      background: 'transparent',
      border: 'none'
    },
    onClick: function onClick(e) {
      var _window;

      e.preventDefault();

      if ((_window = window) !== null && _window !== void 0 && _window.CKFinder) {
        CKFinder.modal({
          chooseFiles: false,
          displayFoldersPanel: false,
          removeModules: 'Maximize,EditImage',
          pass: 'token',
          token: token,
          width: 800,
          height: 600
        });
        return false;
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPhotoVideo.faPhotoVideo,
    className: "nav-icon",
    "data-testid": "nav-icon-file-manager"
  }), /*#__PURE__*/_react["default"].createElement("span", null, "File Manager"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-top"
  }, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "nav-list pb-2 pb-lg-0"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.UserIcon, {
    className: "nav-list-item pb-0",
    "data-testid": "user-profile"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    className: "cursor-pointer nav-list-item py-0 align-self-end",
    "data-testid": "logout",
    onClick: function onClick() {
      return logout();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "brand-color"
  }, "Logout"))))));
};

var _default = (0, _reactRouter.withRouter)(Menu);

exports["default"] = _default;